import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
// reactstrap components
import { Button, Card, UncontrolledTooltip, Row, Col } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import Loader from "../common/Loader";
import BootstrapTable from "react-bootstrap-table-next";
import {
  disableBodyScroll,
  enableBodyScroll,
} from "body-scroll-lock";
import classNames from "classnames";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface DetailParams {
  meetingId: number;
  nodeId: number;
}
interface ISurveyPermission {
  canEdit: boolean;
  canEvent: boolean;
  canClear: boolean;
  canView: boolean;
  canVote: boolean;
  canViewODG: boolean
}

const SurveyList: React.FC<DetailParams> = ({ meetingId, nodeId }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme, selectedLanguageId } = rootStore.commonStore;
  const{canViewODG}= rootStore.tenantStore
  const [t] = useTranslation(
    ["surveys", "translation"],
    translationHookOptions
  );

  const {
    loadSurveys,
    surveysArray,
    resetStore,
    loadSurveysBynode,
    setIsSmallModalOpen,
    showSurveyModal,
    setIsModalOpen,
    setSurveyId,
    setActionName,
    setView,
    resetSurveyDetails,
  } = rootStore.surveyStore;

  const [surveyPermission, setSurveyPermission] = useState<ISurveyPermission>({
    canEvent: false,
    canClear: false,
    canEdit: false,
    canView: false,
    canVote: false,
    canViewODG: false
  });

  const selectStatusCategoryOptions = {
    Aperto: t("survey_list_table_status_filter_open"),
    Chiuso: t("survey_list_table_status_filter_closed"),
    Archiviato: t("survey_list_table_status_filter_archived"),
  };

  function SurveyTypeFormatter(cell: any, row: any) {
    let format = "";
    if (cell === "1") format = t("survey_list_table_survey_filter_single");
    if (cell === "2") format = t("survey_list_table_survey_filter_multiple");
    if (cell === "3") format = t("survey_list_table_survey_filter_rating");
    if (cell === "4") format = t("survey_list_table_survey_filter_free");

    return <span> {format}</span>;
  }

  function SurveyStatusFormatter(cell: any, row: any) {
    let format = "";
    if (cell === "Aperto") format = t("survey_list_table_status_filter_open");
    if (cell === "Chiuso") format = t("survey_list_table_status_filter_closed");
    if (cell === "Archiviato") format = t("survey_list_table_status_filter_archived");

    return <span> {format}</span>;
  }

  function SurveyCategoryFormatter(cell: any, row: any) {
    let format = "";
    if (cell === "SI") format = t("survey_list_table_category_filter_odg");
    else format = t("survey_list_table_category_filter_generic");
    return <span> {format}</span>;
  }

  const selectSurveyCategoryOptions = {
    SI: t("survey_list_table_category_filter_odg"),
    NO: t("survey_list_table_category_filter_generic"),
  };

  const selectSurveyTypeOptions = {
    1: t("survey_list_table_survey_filter_single"),
    2: t("survey_list_table_survey_filter_multiple"),
    3: t("survey_list_table_survey_filter_rating"),
    4: t("survey_list_table_survey_filter_free"),
  };

  const OpenModal = (surveyId: number, ActionName: string) => {
    setActionName(ActionName);
    setSurveyId(surveyId);
    setIsSmallModalOpen(true);
  };

  useEffect(() => {
    // clearAllBodyScrollLocks();
    const scrollableElement = document.querySelector(".surveyList");
    if (scrollableElement)
      disableBodyScroll(scrollableElement, {
        allowTouchMove: (el) => el,
      });
    let isMounted = true;
    // let intNodeId = nodeId;
    let intNodeId = null;
    let intMeetingId = meetingId;
    if (intMeetingId && !intNodeId) {
      loadSurveys(intMeetingId, selectedLanguageId)
        .then((dto) => {
          dto &&
            isMounted &&
            setSurveyPermission({
              canEdit: dto.canEdit,
              canClear: dto.canClear,
              canEvent: dto.canEvent,
              canView: dto.canView,
              canVote: dto.canVote,
              canViewODG: dto.canViewODG
            });
        })
        .catch();
    } else {
      //  history.push("../meetings")
    }

    if (intNodeId) {
      loadSurveysBynode(intNodeId)
        .then((dto) => {
          dto &&
            isMounted &&
            setSurveyPermission({
              canEdit: dto.canEdit,
              canClear: dto.canClear,
              canEvent: dto.canEvent,
              canView: dto.canView,
              canVote: dto.canVote,
              canViewODG: dto.canViewODG
            });
        })
        .catch();
    }

    return () => {
      const scrollableElement = document.querySelector(".surveyList");
      if (scrollableElement) enableBodyScroll(scrollableElement);
      isMounted = false;
      resetStore();
    };
  }, [
    loadSurveys,
    loadSurveysBynode,
    meetingId,
    resetStore,
    selectedLanguageId,
  ]);

  const editFormatter = (cell: any, row: any, rowIndex: any, extra: any) => {
    return (
      <>
        {extra.canEdit && row.open_Close !== "Archiviato" && (
          <>
            <Button
              id={`lnkEdit_${row.id}`}
              color="link"
              onClick={() => {
                setSurveyId(row.id);
                setView("addEdit");
              }}
              disabled={
                row.open_Close === "Aperto" || row.isVotes === true
                  ? true
                  : false
              }
            >
              <i className="fad fa-edit fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`lnkEdit_${row.id}`}
            >
              {t("survey_operation_edit")}
            </UncontrolledTooltip>
          </>
        )}

        {extra.canVote && row.open_Close !== "Archiviato" && (
          <>
            <Button
              id={`btnVote_${row.id}`}
              color="link"
              onClick={() => {
                setSurveyId(row.id);
                setView("vote");
              }}
              disabled={row.open_Close === "Chiuso"}
            >
              {/* <i className="fas fa-person-booth fa-lg text-default iconBoxList"></i> */}
              <i className="fad fa-tasks fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`btnVote_${row.id}`}
            >
              {t("survey_operation_vote")}
            </UncontrolledTooltip>
          </>
        )}

        {extra.canView && (
          <>
            <Button
              id={`lnkResult_${row.id}`}
              color="link"
              onClick={() => {
                setSurveyId(row.id);
                setView("result");
              }}
            >
              {/* <i className="fad fa-poll fa-lg text-default iconBoxList"></i> */}
              <i className="fad fa-analytics  fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`lnkResult_${row.id}`}
            >
              {t("survey_operation_results")}
            </UncontrolledTooltip>
          </>
        )}

        {extra.canEvent && row.open_Close === "Chiuso" && (
          <>
            <Button
              id={`btnOpen_${row.id}`}
              color="link"
              className=""
              onClick={() => OpenModal(row.id, "Open")}
              disabled={!extra.canEvent}
            >
              <i className="fad fa-lock fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`btnOpen_${row.id}`}
            >
              {t("survey_operation_open")}
            </UncontrolledTooltip>
          </>
        )}
        {extra.canEvent && row.open_Close === "Aperto" && (
          <>
            <Button
              id={`btnClose_${row.id}`}
              color="link"
              onClick={() => OpenModal(row.id, "Close")}
              disabled={!extra.canEvent}
            >
              <i className="fad fa-lock-open  fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`btnClose_${row.id}`}
            >
              {t("survey_operation_close")}
            </UncontrolledTooltip>
          </>
        )}
        {extra.canClear && row.open_Close !== "Archiviato" && (
          <>
            <Button
              id={`btnClear_${row.id}`}
              color="link"
              onClick={() => OpenModal(row.id, "Clear")}
              disabled={!extra.canClear}
            >
              <i className="fas fa-eraser fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`btnClear_${row.id}`}
            >
              {t("survey_operation_goto_zero")}
            </UncontrolledTooltip>
          </>
        )}

        {extra.canEvent && row.open_Close !== "Archiviato" && (
          <>
            <Button
              id={`btnArchivie_${row.id}`}
              color="link"
              onClick={() => OpenModal(row.id, "Archivie")}
              disabled={!extra.canEvent}
            >
              <i className="fad fa-archive fa-lg text-default iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`btnArchivie_${row.id}`}
            >
              {t("survey_operation_archive")}
            </UncontrolledTooltip>
          </>
        )}

        {extra.canEdit && row.open_Close !== "Archiviato" && (
          <>
            <Button
              id={`btnDelete_${row.id}`}
              color="link"
              onClick={() => OpenModal(row.id, "Delete")}
              disabled={!extra.canEdit}
            >
              <i className="fas fa-trash-alt fa-lg text-danger iconBoxList"></i>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="top"
              target={`btnDelete_${row.id}`}
            >
              {t("survey_operation_delete")}
            </UncontrolledTooltip>
          </>
        )}
      </>
    );
  };

  const styleProperty: React.CSSProperties = {
    fontWeight: 600,
  };

  const columns = [
    {
      dataField: "question",
      text: t("survey_list_table_name_column"),
      sort: false,
      style: styleProperty,
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "odg",
      text: t("survey_list_table_category_column"),
      sort: true,
      style: styleProperty,
      formatter: SurveyCategoryFormatter,
      filter:  canViewODG &&  selectFilter({
        placeholder: t("survey_list_table_filter_all"),
        options:  selectSurveyCategoryOptions,
      }) ,
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "open_Close",
      text: t("survey_list_table_status_column"),
      sort: true,

      style: styleProperty,
      formatter: SurveyStatusFormatter,
      filter: selectFilter({
        placeholder: t("survey_list_table_filter_all"),
        options: selectStatusCategoryOptions,
      }),
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "surveyType",
      text: t("survey_list_table_name_column"),
      sort: true,
      style: styleProperty,
      formatter: SurveyTypeFormatter,
      filter: selectFilter({
        placeholder: t("survey_list_table_filter_all"),
        options: selectSurveyTypeOptions,
      }),
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "vote",
      text: t("survey_list_table_type_column"),
      sort: false,
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "isVotes",
      hidden: true,
      text: "isVotes",
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
    {
      dataField: "edit",
      isDummyField: true,
      text: t("survey_list_table_ops_column"),
      formatter: editFormatter,
      formatExtraData: surveyPermission,
      classes: "customTableRow",
      headerClasses: "customTableHeaderRow",
    },
  ];

  const newSurvey = () => {
    resetSurveyDetails();
    setView("addEdit");
  };

  if (!surveysArray) return <Loader />;

  return (
    <>
      <div className="surveyList">
        <div
          className={classnames(
            "surveyContentTitle",
            `${theme!.titleBarBgSurvey} ${theme!.titleBarTextSurvey}`
          )}
        >
          {t("surveys_list_title")}
        </div>
        <Row>
          <div className="col">
            <Button
              onClick={() => setIsModalOpen(!showSurveyModal)}
              className={classNames(
                "surveyButton",
                `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                  theme!.buttonTextColor
                }`
              )}
            >
              <span className="btn-inner--icon">
                <i className="fas fa-arrow-left" />
              </span>
              <span className="btn-inner--text">
                {" "}
                {t("back", { ns: "translation" })}
              </span>
            </Button>
          </div>
          {surveyPermission.canEdit ? (
            <Button
              className={classNames(
                "surveyButton ml-auto mr-3",
                `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                  theme!.buttonTextColor
                }`
              )}
              onClick={() => newSurvey()}
            >
              {t("new_survey_button")}
            </Button>
          ) : null}
        </Row>
        <Row className="mt-4">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="customSurveysCard">
              <div>
                <BootstrapTable
                  // {...props.baseProps}
                  classes="align-items-center surveyTable"
                  bodyClasses="surveyTableBody"
                  headerWrapperClasses="surveyTableHeader"
                  // pagination={paginationFactory()}
                  filter={filterFactory()}
                  filterPosition="top"
                  bootstrap4={true}
                  bordered={false}
                  wrapperClasses="table-responsive"
                  columns={columns}
                  keyField="id"
                  data={surveysArray}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default observer(SurveyList);
